export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10342.0ab60554.jpg";